import { MediaItem } from 'src/components/tag-popup/Components/MediaItem';
import { Gallery } from 'src/components/gallery/Gallery';
import { DeviceManager, isGifUrl, isVimeoUrl, isYoutubeUrl } from 'src/utils';
import { getVideoLink } from 'src/utils/getVideoLink';
import { MediaItemStyle } from 'src/components/tag-popup/Components/types';

export const renderMediaContent = (tag, inFullScreen, toggleFullScreen, pauseTourMusic) => {
  const hasVideoUrl =
    (tag?.showVideoUrl && tag?.videoUrl && tag?.videoUrl !== 'null') ||
    (Array.isArray(tag?.galleries) &&
      tag.galleries.some(
        (item) => typeof item?.url === 'string' && item.url.match(/\.(mp4|mov|avi|webm|mkv)$/i),
      ));
  if (hasVideoUrl && !!pauseTourMusic) pauseTourMusic();

  if (tag.tagGalleries?.length === 1 && !hasVideoUrl) {
    return (
      <MediaItem
        url={tag.tagGalleries[0].url}
        type={MediaItemStyle.Popup}
        inFullScreen={inFullScreen}
        toggleFullScreen={toggleFullScreen}
      />
    );
  }
  if (tag.tagGalleries?.length) {
    return (
      <>
        <Gallery
          items={[
            ...(hasVideoUrl ? [tag.videoUrl] : []),
            ...tag.tagGalleries
              .sort((firstItem, secondItem) => {
                if (firstItem.order < secondItem.order) {
                  return -1;
                }
                if (firstItem.order > secondItem.order) {
                  return 1;
                }
                return 0;
              })
              .map((galleryItem: any) => `${process.env.NEXT_PUBLIC_CDN}${galleryItem.url}`),
          ]}
          settings={{
            dots: true,
            controlArrows: true,
            imageHeight: DeviceManager.isMobile() ? 400 : 600,
          }}
        />
      </>
    );
  }

  if (hasVideoUrl) {
    if (isGifUrl(tag.videoUrl))
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={tag.videoUrl} />
        </div>
      );
    if (isYoutubeUrl(tag.videoUrl) || isVimeoUrl(tag.videoUrl))
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <iframe
            style={{ width: '100%', height: DeviceManager.isMobile() ? 'auto' : '500px' }}
            src={getVideoLink(tag.videoUrl)}
          ></iframe>
        </div>
      );
  }
  return null;
};
